/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdditionalProjectInformationFieldDto } from '../../models/backend-additional-project-information-field-dto';

export interface ProjectsAdditionalProjectInformationRetrieve$Params {
  id: number;
}

export function projectsAdditionalProjectInformationRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsAdditionalProjectInformationRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsAdditionalProjectInformationRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>;
    }),
  );
}

projectsAdditionalProjectInformationRetrieve.PATH = '/api/projects/additional_project_information/{id}/';
